export const Spiral = ({ color = "black" }: { color?: "black" | "white" }) => {
  const getFillColor = () => {
    if (color === "black") return "fill-[#231F20]";
    if (color === "white") return "fill-[#fff]";
  };

  return (
    <svg
      className={getFillColor()}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 200 200"
    >
      <g>
        <path
          d="M127.5,132.4c-1.3-5.9-4.5-11.4-9.5-15c-14-10.9-38.2-4.5-39.5,14.5c-5.9,0.2-11.8,0.6-17.7,1.1
		c-1-9.5,1.2-19.4,6.7-27.4c6.2-9.1,16.6-15.4,27.8-16.1c-23.7-1.2-41.7,19.9-42.2,42.8c0,0.5,0,0.9,0,1.4
		c-6.1,0.7-12.1,1.6-18.2,2.7c7.1,1.4,14.3,2.4,21.5,3.1c5.1,21.1,28,36.4,49.8,29.5c10-3.4,18-11.8,20.7-22c0.6-2.1,1-4.3,1.1-6.5
		c1.8-0.1,3.6-0.3,5.3-0.4c-0.1,8.8-3.1,17.7-8,25.1c-5.7,8.8-14.7,16-25.6,16.9c22.4,1.2,40.4-21.8,43.2-42.9
		c5.7-0.7,11.5-1.5,17.2-2.6C149.4,134.3,138.5,133.1,127.5,132.4z M81.2,141.1c2,7.2,8.6,12.4,16.4,12.4c7.8,0,14.4-5.2,16.4-12.4
		c0.7,0,1.4-0.1,2.1-0.1c-0.3,6.6-3.7,13.2-9.1,17.1c-11.8,8.7-28.8,4.5-38.7-5.4c-3.8-3.8-6.5-8.2-8.2-12.9
		C67.2,140.5,74.2,140.9,81.2,141.1z"
        />
        <path
          d="M71.5,128.8c3.7-10.2,10.8-19.6,21.5-22.6c10-2.7,21.6-0.9,30.1,5.1c5.9,4.1,10.5,10.2,13.7,17.3
		c-0.6-7.8-4.2-15.7-10.4-21.3c-9.3-8.5-23.5-11.4-35.5-7.5C78.8,103.5,70.5,116.7,71.5,128.8z"
        />
      </g>
    </svg>
  );
};
